import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-cv-file',
  templateUrl: './cv-file.component.html',
  styleUrls: ['./cv-file.component.scss']
})
export class CvFileComponent implements OnInit, OnChanges {

  @Input()
  public fileUrl: string;
  @Input()
  public viewFormat: string = 'google';
  public fullFilePath: string;

  constructor() { }

  ngOnInit(): void {
    console.log("Initializing preview "+ this.fileUrl);
    this.fullFilePath = environment.apiURL +"/api/v1/cv" + this.fileUrl;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.fileUrl?.currentValue) {
      this.fullFilePath = environment.apiURL +"/api/v1/cv" + this.fileUrl;
    }
  }

}
